import { ROUTER_PATHS, gridSizeMdLg6, gridSizeMdLg4, gridSizeMdLg2, gridSizeMdLg3, gridSizeMdLg8 } from "@/shared";
import {
    CustomNumberTextField,
    CustomSelectTextField,
    CustomTextArea, CustomTextAreaNoForm,
    CustomTextField,
    CustomTextFieldNoForm,
    LoaderComponent, SampleTable, SingleFormBoxScene,
    SingleTableBoxScene, TabTexLabelCustomSpace, TabTextLabel
} from "@/shared/components/ui";
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Button, Divider, Grid, Input, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Add, ArrowBack, ExpandMore, QrCode, DeleteForever } from '@mui/icons-material';
import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup';
import { OrdenTrabajoNoc, ActividadesFibra, EquipmentUsed } from "@/shared/interfaces/erp/noc/orden-trabajo-noc.interface";
import { useNavigate, useParams } from "react-router-dom";
import { MRT_ColumnDef } from "material-react-table";
import { toast } from "react-toastify";
import { useFetchWorkOrderById, useUpdateWorkOrder } from "../../actions/noc-module.actions";
import ListaImagen from "../../components/ListaImagen";
import TimeClockComponente from "@/shared/components/ui/TimeClock/TimeClockComponente";
import AddPhotosModal from "../../components/AddPhotosModal";
import AddEquipamentsModal from "../../components/AddEquipamentsModal";
import SelectSeriesModal from "../../components/SelectSeriesModal";
import { useFetchCreateTransferenciaInventario } from "@/shared/actions/erp";
import { useUiConfirmModalStore } from "@/store/ui";
import RemoverEquipamentsModal from "../../components/RemoverEquipamentsModal";

type SaveFormData = Omit<OrdenTrabajoNoc, 'workOrderId'>;

export default function InformeOrdenTrabajoNoc() {

    const { id } = useParams();

    const navigate = useNavigate();
    const returnUrlOrdenTrabajoPage = ROUTER_PATHS.tecnico.ordenesNocNav;
    const username = JSON.parse(localStorage.getItem("auth") || "{}")?.state?.user?.username;

    const [openAddPhotosModal, setOpenAddPhotosModal] = useState(false);
    const [idActivitiesOrder, setIdActivitiesOrder] = useState('');
    const [codeUbicacionActivitiesOrder, setCodeUbicacionActivitiesOrder] = useState('');

    const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
    const setConfirmDialogIsOpen = useUiConfirmModalStore((s) => s.setConfirmDialogIsOpen);

    const [openAddEquipamentsModal, setOpenAddEquipamentsModal] = useState(false);
    const [openRemoverEquipamentsModal, setOpenRemoverEquipamentsModal] = useState(false);
    const [openSelectSeriesModal, setOpenSelectSeriesModal] = useState({
        status: false,
        activityIndex: 0,
        equipmentIndex: 0,
        data: [] as any[],
    });

    const listaEstadosOrden = () => {
        return [
            { id_estado: 'PENDIENTE', nombre: 'PENDIENTE' },
            { id_estado: 'REALIZADO', nombre: 'REALIZADO' },
        ];
    }

    const listaEstadosActividad = () => {
        return [
            { id_estado: 'PENDIENTE', nombre: 'PENDIENTE' },
            { id_estado: 'REALIZADO', nombre: 'REALIZADO' },
            { id_estado: 'CANCELADO', nombre: 'CANCELADO' },
        ];
    }

    // hook para registrar orden de trabajo noc
    const useUpdateWorkOrderMutation = useUpdateWorkOrder(id);

    // hook para obtener orden de trabajo noc
    const {
        isLoading,
        data: workOrderRes,
        refetch
    } = useFetchWorkOrderById({
        workOrderId: id as string
    }, {
        enabled: !!id
    }) as any;

    const newOrdenTrabajoSchema = yup.object({
        fleetCode: yup.string().required('La flota es requerida'),
        workDate: yup.date().required('La fecha de trabajo es requerida'),
        orderName: yup.string().required('El nombre es requerido'),
        startTimeOrder: yup.string().required('Inicio de la Jornada es requerido'),
        endTimeOrder: yup.string().required('Fin de la Jornada es requerido')
            .test(
                'end-after-start',
                'La hora de fin debe ser mayor que la hora de inicio',
                function (endTime) {
                    const { startTimeOrder } = this.parent;
                    if (!startTimeOrder || !endTime) {
                        return true; // required se encarga de validar vacíos
                    }
                    return endTime > startTimeOrder;
                }
            ),
        lunchTime: yup.number().required('Cantidad Horas de almuerzo es requerido').min(0, 'La cantidad debe ser valida').max(2, 'La cantidad debe ser valida'),
        overtime: yup.number().required('Horas extras es requerido').min(0, 'La cantidad debe ser valida').max(10, 'La cantidad debe ser valida'),
    });

    const form = useForm<SaveFormData>({
        resolver: yupResolver(newOrdenTrabajoSchema as any),
        defaultValues: {
            fleetCode: '',
            workDate: '',
            orderName: '',
            mobilizationValue: 0,
            startTimeOrder: '',
            endTimeOrder: '',
            lunchTime: '',
            overtime: '',
            startTimeOrder2: '',
            endTimeOrder2: '',
            lunchTime2: '',
            overtime2: '',
            activitiesOrder: [] as ActividadesFibra[],
        },
    });

    useEffect(() => {
        // workOrderRes esta tipado como {} por el hook generico; en runtime
        // viene { data: OrdenTrabajoNoc }. Cast a any para destructurar .data.
        const wr = workOrderRes as any;
        if (wr?.data) {
            form.reset({
                ...workOrderRes.data,
                startTimeOrder: parseTimeToDate(workOrderRes.data.startTimeOrder),
                endTimeOrder: parseTimeToDate(workOrderRes.data.endTimeOrder),
                startTimeOrder2: parseTimeToDate(workOrderRes.data.startTimeOrder2),
                endTimeOrder2: parseTimeToDate(workOrderRes.data.endTimeOrder2),
                activitiesOrder: workOrderRes.data.activitiesOrder.map((activity: any) => ({
                    ...activity,
                    startTime: parseTimeToDate(activity.startTime),
                    endTime: parseTimeToDate(activity.endTime),
                }))
            });
        }
    }, [workOrderRes, form]);

    const {
        control,
        handleSubmit,
        formState: { errors, isValid },
    } = form;

    const formatLocalTime = (date: Date | string | null) => {
        if (!date) return null;
        const d = new Date(date);
        return d.toTimeString().split(' ')[0]; // HH:mm:ss
    };

    const parseTimeToDate = (time: string | null) => {
        if (!time) return null;
        const [h, m, s] = time.split(':');
        const date = new Date();
        date.setHours(Number(h), Number(m), Number(s || 0), 0);
        return date;
    };


    // para descargar equipamiento
    const {
        mutateAsync: mutateAsyncTransferenciaProducto,
        isPending: isPendingTrasladoInventario
    } = useFetchCreateTransferenciaInventario();

    const onEquipmentTraslado = async (idActivitiesOrder: string) => {
        const activities = form.getValues('activitiesOrder');
        for (const item of activities) {
            if (item.idActivitiesOrder === idActivitiesOrder) {
                let dataProducto = [];
                let originStoreCode = "";
                let originLocationCode = "";
                let destinationStoreCode = "";
                let destinationLocationCode = "";
                for (const eItem of item.equipmentUsed) {
                    if (eItem.idEquipmentUsed === '') {

                        if (eItem.amountProductUsed <= 0) {
                            toast.error("Debe ingresar una cantidad valida del producto " + eItem.descriptionEquipmentUsed);
                            return false;
                        }

                        if (eItem.requiresSeries && !eItem.seriesProductUsed) {
                            toast.error("Debe ingresar la serie del producto " + eItem.descriptionEquipmentUsed);
                            return false;
                        }

                        originStoreCode = eItem.originStoreCode;
                        originLocationCode = eItem.originLocationCode;
                        destinationStoreCode = eItem.destinationStoreCode;
                        destinationLocationCode = eItem.destinationLocationCode;
                        if (eItem.usaMeters) {
                            dataProducto.push({
                                codigo: eItem.codeProductUsed,
                                cantidad: "1",
                                series: [eItem.seriesProductUsed],
                                cantidad_metros: eItem.amountProductUsed,
                                series_metros: {
                                    [eItem.seriesProductUsed]: eItem.amountProductUsed
                                }
                            });
                        } else {
                            if (eItem.requiresSeries) {
                                dataProducto.push({
                                    codigo: eItem.codeProductUsed,
                                    cantidad: eItem.amountProductUsed + "",
                                    series: [eItem.seriesProductUsed]
                                });
                            } else {
                                dataProducto.push({
                                    codigo: eItem.codeProductUsed,
                                    cantidad: eItem.amountProductUsed + "",
                                    series: []
                                });
                            }
                        }
                    }
                }

                const payloadEquipment: any = {
                    bodega_origen: originStoreCode,
                    ubicacion_origen: originLocationCode,
                    bodega_destino: destinationStoreCode,
                    ubicacion_destino: destinationLocationCode,
                    productos: dataProducto,
                };

                if (dataProducto.length > 0) {
                    try {
                        await mutateAsyncTransferenciaProducto(payloadEquipment);
                        onSave(0)
                    } catch (err) {
                        console.error("Error al crear traslado de inventario:", err);
                        toast.error("Error al crear traslado de inventario: " + (err as any)?.message || "Error desconocido");
                    }
                }

            }
        }
    };

    const onSave = (valor: number) => {

        const values = form.getValues();
        let orderStatusAux = "PENDIENTE";
        if (valor === 1) {
            if (!isValid) return;

            if (form.getValues().activitiesOrder.length === 0) {
                toast.error("Debe agregar al menos una actividad");
                return false;
            }
            if (form.getValues().orderStatus == 'REALIZADO' && form.getValues().startTimeOrder === '') {
                toast.error("Ingrese la Hora Inicio de la orden");
                return false;
            }
            if (form.getValues().orderStatus == 'REALIZADO' && form.getValues().endTimeOrder === '') {
                toast.error("Ingrese la Hora Final de la orden");
                return false;
            }

            if (form.getValues().activitiesOrder.some(activity => activity.activityStatus === "PENDIENTE")) {
                toast.error("No se han completado aun las actividades para cerrar la orden");
                return false;
            }
            orderStatusAux = "REALIZADO";
        }

        const payload = {
            ...values,
            orderStatus: orderStatusAux,
            startTimeOrder: formatLocalTime(values.startTimeOrder),
            endTimeOrder: formatLocalTime(values.endTimeOrder),
            startTimeOrder2: formatLocalTime(values.startTimeOrder2),
            endTimeOrder2: formatLocalTime(values.endTimeOrder2),
            userModify: username,
            activitiesOrder: values.activitiesOrder.map(activity => ({
                ...activity,
                startTime: formatLocalTime(activity.startTime),
                endTime: formatLocalTime(activity.endTime),
            }))
        };

        useUpdateWorkOrderMutation.mutate(payload, {
            onSuccess: () => {
                refetch()
                if (valor === 1) {
                    navigate(returnUrlOrdenTrabajoPage);
                }
                toast.success("Orden Actualizada correctamente")
            },
            onError: (error) => {
                console.error('Error al actualizar la orden de trabajo:', error);
                toast.error('Error al actualizar la orden de trabajo');
            }
        });
    };

    const handleSubmitForm = () => {
        onSave(1);
    };

    const dataMapped: ActividadesFibra[] = (form.getValues().activitiesOrder);

    const columns = (activityIndex: number): MRT_ColumnDef<EquipmentUsed>[] => [
        {
            header: "ACCION",
            accessorKey: "idEquipmentUsed",
            size: 10,
            Cell: ({ row }) => {
                if (row.original.idEquipmentUsed === '') {
                    const handleDelete = () => {

                        const path = `activitiesOrder.${activityIndex}.equipmentUsed` as any;

                        const current = form.getValues(path) || [];

                        const updated = current.filter(
                            (_: EquipmentUsed, i: number) => i !== row.index
                        );

                        form.setValue(path, updated, {
                            shouldDirty: true,
                            shouldValidate: true,
                            shouldTouch: true,
                        });
                    };

                    return (
                        <Button
                            color="error"
                            onClick={handleDelete}
                        >
                            <DeleteForever />
                        </Button>
                    );
                }
            }
        },
        {
            header: "PRODUCTO",
            accessorKey: "nameProductUsed",
            size: 200,
        },
        {
            header: "CANTIDAD",
            accessorKey: "amountProductUsed",
            size: 50,
            Cell: ({ row }) => {
                const name = `activitiesOrder.${activityIndex}.equipmentUsed.${row.index}.amountProductUsed` as const;
                const value = useWatch({
                    control: form.control,
                    name,
                });

                if (row.original.idEquipmentUsed !== '') return value

                return (
                    <Input
                        readOnly={row.original.requiresSeries && !row.original.usaMeters ? true : false}
                        type="number"
                        value={value ?? 0}
                        minRows={1}
                        style={{ textAlign: 'center' }}
                        onChange={(e) => {
                            const newAmount = Number(e.target.value);
                            if (isNaN(newAmount)) return;

                            form.setValue(name, newAmount, {
                                shouldDirty: true,
                                shouldValidate: true,
                            });
                        }}
                    />
                );
            }
        },
        {
            header: "SERIE",
            accessorKey: "seriesProductUsed",
            size: 50,
            Cell: ({ row }) => {
                const requiresSeries = row.original.requiresSeries;

                if (!requiresSeries) {
                    return <Typography variant="body2" color="textSecondary">No requiere serie</Typography>;
                }
                return (
                    <>
                        {row.original.idEquipmentUsed !== '' ? (
                            <>{row.original.seriesProductUsed}</>
                        ) : (
                            <>
                                <Button color={'primary'} onClick={() =>
                                    setOpenSelectSeriesModal({ status: true, activityIndex: activityIndex, equipmentIndex: row.index, data: row.original.series_data || [] })
                                }>
                                    <QrCode />
                                </Button>
                                {row.original.seriesProductUsed}
                            </>
                        )}
                    </>
                )
            },
        },
        {
            header: "ESTADO PRODUCTO",
            accessorKey: "statusProductUsed",
            size: 50,
        },
    ];

    // Helper para manejar errores con focus y scroll
    const handleValidationError = (fieldPath: string, message: string) => {
        try {
            // Hacer focus al campo
            form.setFocus(fieldPath as any);

            // Buscar el elemento en el DOM por su nombre
            const inputElement = document.querySelector(`[name="${fieldPath}"]`) as HTMLElement;
            if (inputElement) {
                // Scroll al elemento
                inputElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

                // Agregar highlight visual temporal
                const originalBorder = inputElement.style.border;
                inputElement.style.border = '2px solid #d32f2f';
                inputElement.style.boxShadow = '0 0 0 3px rgba(211, 47, 47, 0.2)';

                // Remover el highlight después de 2 segundos
                setTimeout(() => {
                    inputElement.style.border = originalBorder;
                    inputElement.style.boxShadow = '';
                }, 3000);
            }

            // Mostrar toast
            toast.error(message);
        } catch (error) {
            console.error('Error en validación:', error);
            toast.error(message);
        }
    };

    const onRealizado = (index: number, estado_actividad: string) => {
        // validaciones
        const activitySelect = form.getValues().activitiesOrder[index];

        if (estado_actividad == 'REALIZADO' && !activitySelect.startTime) {
            handleValidationError(`activitiesOrder.${index}.startTime`, "Debe completar la hora Inicial");
            return;
        }
        if (estado_actividad == 'REALIZADO' && !activitySelect.endTime) {
            handleValidationError(`activitiesOrder.${index}.endTime`, "Debe completar la hora Final");
            return;
        }
        if (estado_actividad == 'REALIZADO' && activitySelect.incidents.requireCoordinates) {
            if (!activitySelect.initialCoordinate) {
                handleValidationError(`activitiesOrder.${index}.initialCoordinate`, "Debe ingresar la coordenada inicial");
                return;
            }
            if (!activitySelect.finalCoordinate) {
                handleValidationError(`activitiesOrder.${index}.finalCoordinate`, "Debe ingresar la coordenada final");
                return;
            }
        }
        if ((estado_actividad == 'REALIZADO' || estado_actividad == 'CANCELADO') && !activitySelect.reportActivity?.trim()) {
            handleValidationError(`activitiesOrder.${index}.reportActivity`, "Debe ingresar un informe de la actividad");
            return;
        }

        if (estado_actividad == 'REALIZADO' && (activitySelect.photosReports?.length || 0) < 2) {
            toast.error("Debe ingresar al menos dos fotografías.");
            return;
        }

        if (estado_actividad == 'CANCELADO' && (activitySelect.equipmentUsed?.length || 0) > 0) {
            toast.error("No se puede cancelar la actividad, existe equipamiento agregado.");
            return;
        }

        if (estado_actividad == 'REALIZADO') {
            for (const [equipmentIndex, equipment] of activitySelect.equipmentUsed.entries()) {
                if (!equipment.idEquipmentUsed) {
                    console.log(equipmentIndex, " < equipment pendiente de guardar", equipment);
                    toast.error("Existe productos pendientes de guardar. Guárdelo o retírelo de la lista de equipamiento.");
                    return false;
                }
            }

            for (const [index, activity] of form.getValues().activitiesOrder.entries()) {
                for (const [equipmentIndex, equipment] of activity.equipmentUsed.entries()) {
                    if (!equipment.idEquipmentUsed) {
                        console.log(equipmentIndex, " < equipment pendiente de guardar", equipment, " en actividad ", index, activity);
                        toast.error("Existe una actividad con productos pendientes de guardar. Por favor validarlo.");
                        return false;
                    }
                }
            }
        }

        setConfirmDialog({
            isOpen: true,
            subtitle: "¿Está seguro que desea enviar la actividad seleccionada como " + estado_actividad + "?",
            title: "Confirmar",
            onConfirm: () => {

                const payload = {
                    ...form.getValues(),
                    startTimeOrder: formatLocalTime(form.getValues().startTimeOrder),
                    endTimeOrder: formatLocalTime(form.getValues().endTimeOrder),
                    startTimeOrder2: formatLocalTime(form.getValues().startTimeOrder2),
                    endTimeOrder2: formatLocalTime(form.getValues().endTimeOrder2),
                    userModify: username,
                    activitiesOrder: form.getValues().activitiesOrder.map(activity => ({
                        ...activity,
                        startTime: formatLocalTime(activity.startTime),
                        endTime: formatLocalTime(activity.endTime),
                        activityStatus: activity.idActivitiesOrder === activitySelect.idActivitiesOrder ? estado_actividad : activity.activityStatus,
                    }))
                };
                useUpdateWorkOrderMutation.mutate(payload, {
                    onSuccess: () => {
                        refetch();
                        toast.success("Orden Actualizada correctamente")
                        setConfirmDialogIsOpen(false);
                    },
                    onError: (error) => {
                        console.error('Error al actualizar la orden de trabajo:', error);
                        toast.error('Error al actualizar la orden de trabajo');
                    }
                });
            },
            onClose() {
                setConfirmDialogIsOpen(false);
            }
        });
    };


    // spinner hasta cargar la orden de trabajo
    if (isLoading || isPendingTrasladoInventario) {
        return <LoaderComponent />
    }

    return (
        <>
            <SingleTableBoxScene
                title={`Informe Orden de Trabajo`}
                textRedirect={"Atras"}
                iconRedirect={<ArrowBack />}
                urlRedirect={`${returnUrlOrdenTrabajoPage}`}
                visibleReport={true}
            >

                <SingleFormBoxScene
                    titlePage={""}
                    onCancel={() => {
                        navigate(returnUrlOrdenTrabajoPage);
                    }}
                    containerMaxWidth={"xl"}
                    py={6}
                    onSave={handleSubmit(handleSubmitForm)}
                    saveTextBtn={"Enviar Informe"}
                    disableSubmitBtn={
                        form.getValues().orderStatus === "REALIZADO" || form.getValues().orderStatus === "FINALIZADO"
                            ? true
                            : (form.getValues().activitiesOrder.some(activity => activity.activityStatus === "PENDIENTE") ? true : false)
                    }
                >

                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TabTextLabel
                                text={"INFORMACIÓN GENERAL DE LA ORDEN"}
                                mt={0}
                                pb={2}
                                pl={0}
                                pt={2}
                            />
                        </Grid>

                        <CustomSelectTextField<any>
                            label="Estado de la Orden"
                            defaultValue={form.getValues().orderStatus || ''}
                            // options
                            options={listaEstadosOrden() || []}
                            labelKey="nombre"
                            valueKey="id_estado"
                            menuItemKey="id_estado"
                            // errors
                            register={form.register(`orderStatus`)}
                            error={errors.orderStatus}
                            helperText={""}
                            size={gridSizeMdLg6}
                            disabled={true}
                        />

                        <CustomTextFieldNoForm
                            label="Nombre de la Orden"
                            defaultValue={form.getValues().orderName || ''}
                            size={gridSizeMdLg6}
                            disabled={true}
                        />

                        <CustomTextFieldNoForm
                            label="Fecha de Trabajo"
                            defaultValue={form.getValues().workDate || ''}
                            size={gridSizeMdLg6}
                            disabled={true}
                        />
                        <CustomTextFieldNoForm
                            label="Valor Movilización"
                            defaultValue={form.getValues().mobilizationValue || ''}
                            size={gridSizeMdLg6}
                            disabled={true}
                        />

                        <CustomTextFieldNoForm
                            label="Operador Registra"
                            defaultValue={form.getValues().userRegister || ''}
                            size={gridSizeMdLg6}
                            disabled={true}
                        />

                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Divider sx={{ my: 2 }} />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TabTexLabelCustomSpace
                                textContent={"LISTADO DE ACTIVIDADES"}
                            />
                        </Grid>

                        {dataMapped && dataMapped.map((item, index) => {
                            return (
                                <>
                                    <Grid container spacing={3} key={index}>
                                        <Grid item xs={12}>
                                            <Accordion defaultExpanded={item.activityStatus === "PENDIENTE" ? true : false} style={{ border: "1px #689dec solid" }}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMore />}
                                                    aria-controls="panel3-content"
                                                    id="panel3-header"
                                                    style={{ backgroundColor: item.activityStatus === "CANCELADO" ? "#ff00002b" : item.activityStatus === "REALIZADO" ? "#00ff0021" : "#689dec", borderRadius: "8px" }}
                                                >
                                                    <Typography component="span">Actividad # <strong>{item.idActivitiesOrder}</strong> :: {item.activityName}</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <br></br>
                                                    <Grid container spacing={3}>
                                                        <CustomSelectTextField<any>
                                                            label="Estado de la Actividad"
                                                            defaultValue={item.activityStatus || ''}
                                                            // options
                                                            options={listaEstadosActividad() || []}
                                                            labelKey="nombre"
                                                            valueKey="id_estado"
                                                            menuItemKey="id_estado"
                                                            // errors
                                                            register={form.register(`activitiesOrder.${index}.activityStatus`)}
                                                            error={errors.activitiesOrder && errors.activitiesOrder[index]?.activityStatus}
                                                            helperText={""}
                                                            size={gridSizeMdLg4}
                                                            disabled={true}
                                                        />
                                                        <TimeClockComponente
                                                            label="Hora Inicial"
                                                            size={gridSizeMdLg4}
                                                            control={control}
                                                            error={errors.activitiesOrder && errors.activitiesOrder[index]?.startTime}
                                                            name={`activitiesOrder.${index}.startTime`}
                                                            enableDateTypeResult={true}
                                                            disabled={item.activityStatus === "CANCELADO" || item.activityStatus === "REALIZADO" ? true : false}
                                                        />
                                                        <TimeClockComponente
                                                            label="Hora Final"
                                                            size={gridSizeMdLg4}
                                                            control={control}
                                                            error={errors.activitiesOrder && errors.activitiesOrder[index]?.endTime}
                                                            name={`activitiesOrder.${index}.endTime`}
                                                            enableDateTypeResult={true}
                                                            disabled={item.activityStatus === "CANCELADO" || item.activityStatus === "REALIZADO" ? true : false}
                                                        />

                                                        <CustomTextFieldNoForm
                                                            label="Tipo"
                                                            defaultValue={item.type || ''}
                                                            size={gridSizeMdLg4}
                                                            disabled={true}
                                                        />
                                                        <CustomTextFieldNoForm
                                                            label="Actividad"
                                                            defaultValue={item.incidents.activityType.nameActivityType || ''}
                                                            size={gridSizeMdLg4}
                                                            disabled={true}
                                                        />
                                                        <CustomTextFieldNoForm
                                                            label="Incidencia"
                                                            defaultValue={item.incidents.name || ''}
                                                            size={gridSizeMdLg4}
                                                            disabled={true}
                                                        />

                                                        <CustomTextFieldNoForm
                                                            label="Dirigido a"
                                                            defaultValue={item.forTheActivity || ''}
                                                            size={gridSizeMdLg4}
                                                            disabled={true}
                                                        />

                                                        {item.forTheActivity === "CLIENTE" ?
                                                            <>
                                                                <CustomTextFieldNoForm
                                                                    label="Cliente"
                                                                    defaultValue={item.clientName || ''}
                                                                    size={gridSizeMdLg8}
                                                                    disabled={true}
                                                                />
                                                            </>
                                                            :
                                                            <>
                                                                <CustomTextFieldNoForm
                                                                    label="Nodo"
                                                                    defaultValue={item.nodeName || ''}
                                                                    size={gridSizeMdLg8}
                                                                    disabled={true}
                                                                />
                                                            </>
                                                        }

                                                        <CustomTextFieldNoForm
                                                            label="Requiere Coordenadas"
                                                            defaultValue={item.incidents.requireCoordinates ? 'SI' : 'NO'}
                                                            size={gridSizeMdLg2}
                                                            disabled={true}
                                                        />
                                                        <CustomTextField
                                                            label="Coordenada Inicial"
                                                            defaultValue={item.initialCoordinate || ''}
                                                            size={gridSizeMdLg3}
                                                            control={control}
                                                            error={errors.activitiesOrder && errors.activitiesOrder[index]?.initialCoordinate}
                                                            helperText={""}
                                                            name={`activitiesOrder.${index}.initialCoordinate`}
                                                        // disabled={true}
                                                        />
                                                        <CustomTextField
                                                            label="Coordenada Final"
                                                            defaultValue={item.finalCoordinate || ''}
                                                            size={gridSizeMdLg3}
                                                            control={control}
                                                            error={errors.activitiesOrder && errors.activitiesOrder[index]?.finalCoordinate}
                                                            helperText={""}
                                                            name={`activitiesOrder.${index}.finalCoordinate`}
                                                        // disabled={true}
                                                        />
                                                        <CustomTextFieldNoForm
                                                            label="Sector"
                                                            defaultValue={item.sector || ''}
                                                            size={gridSizeMdLg4}
                                                            disabled={true}
                                                        />

                                                        <CustomTextFieldNoForm
                                                            label="Requiere Cajas"
                                                            defaultValue={item.isBoxInstallation ? 'SI' : 'NO'}
                                                            size={gridSizeMdLg2}
                                                            disabled={true}
                                                        />

                                                        <CustomTextFieldNoForm
                                                            label="Listado de Cajas"
                                                            defaultValue={
                                                                item.primarySecondaryBox
                                                                    ?.map((caja) => caja.name)
                                                                    .join(', ') ?? ''
                                                            }
                                                            size={gridSizeMdLg6}
                                                            disabled={true}
                                                        />

                                                        <CustomTextAreaNoForm
                                                            label="Observación de la actividad"
                                                            size={gridSizeMdLg6}
                                                            value={item.activityDetail}
                                                            disabled={true}
                                                        />
                                                        <CustomTextArea
                                                            label="Informe de la actividad"
                                                            size={gridSizeMdLg6}
                                                            // defaultValue={item.reportActivity ?? ''}
                                                            control={control}
                                                            error={errors.activitiesOrder && errors.activitiesOrder[index]?.reportActivity}
                                                            helperText={""}
                                                            name={`activitiesOrder.${index}.reportActivity`}
                                                            disabled={item.activityStatus === "CANCELADO" || item.activityStatus === "REALIZADO" ? true : false}
                                                        />

                                                    </Grid>

                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12}>
                                                            <Divider sx={{ my: 2 }} />
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container spacing={3}>
                                                        <Grid item xs={6}>
                                                            {item.activityStatus === "CANCELADO" || item.activityStatus === "REALIZADO" ? (
                                                                <TabTexLabelCustomSpace
                                                                    textContent={"Equipamiento Instalado"}
                                                                />
                                                            ) : (
                                                                <TabTexLabelCustomSpace
                                                                    textContent={"Equipamiento Instalado"}
                                                                    colorBtn={"success"}
                                                                    startIconBtn={<Add />}
                                                                    labelBtn={"Agregar"}
                                                                    onClickBtn={() => {
                                                                        setOpenAddEquipamentsModal(true);
                                                                        setIdActivitiesOrder(item.idActivitiesOrder);
                                                                    }}
                                                                />
                                                            )}
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            {item.activityStatus === "CANCELADO" || item.activityStatus === "REALIZADO" ? (
                                                                <TabTexLabelCustomSpace
                                                                    textContent={"Equipamiento Retirado/Cambiado"}
                                                                />
                                                            ) : (
                                                                <TabTexLabelCustomSpace
                                                                    textContent={"Equipamiento Retirado/Cambiado"}
                                                                    colorBtn={"error"}
                                                                    startIconBtn={<Add />}
                                                                    labelBtn={"Agregar"}
                                                                    onClickBtn={() => {
                                                                        let codeLocation = item.forTheActivity === "CLIENTE" ? item.clientLocationCode : item.nodeLocationCode;
                                                                        setOpenRemoverEquipamentsModal(true);
                                                                        setIdActivitiesOrder(item.idActivitiesOrder);
                                                                        setCodeUbicacionActivitiesOrder(codeLocation ?? "");
                                                                    }}
                                                                />
                                                            )}
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <SampleTable<EquipmentUsed>
                                                                density="compact"
                                                                columns={columns(index)}
                                                                data={item.equipmentUsed || []}
                                                            />
                                                            {item.activityStatus === "CANCELADO" || item.activityStatus === "REALIZADO" ? (
                                                                <></>
                                                            ) : (
                                                                <>
                                                                    <Button size="small" variant="contained" color="success" onClick={() => onEquipmentTraslado(item.idActivitiesOrder)}>Guardar Equipamiento</Button>
                                                                </>
                                                            )}
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12}>
                                                            {item.activityStatus === "CANCELADO" || item.activityStatus === "REALIZADO" ? (
                                                                <TabTexLabelCustomSpace
                                                                    textContent={"FOTOGRAFÍAS"}
                                                                />
                                                            ) : (
                                                                <TabTexLabelCustomSpace
                                                                    textContent={"FOTOGRAFÍAS"}
                                                                    colorBtn={"success"}
                                                                    startIconBtn={<Add />}
                                                                    labelBtn={"Agregar Fotos"}
                                                                    onClickBtn={() => {
                                                                        for (const [equipmentIndex, equipment] of item.equipmentUsed.entries()) {
                                                                            if (!equipment.idEquipmentUsed) {
                                                                                console.log(equipmentIndex, " < equipment pendiente de guardar", equipment);
                                                                                toast.error("Equipamiento pendiente de guardar en la actividad. Guárdelo o retírelo de la lista de equipamiento.");
                                                                                return false;
                                                                            }
                                                                        }
                                                                        for (const [index, activity] of form.getValues().activitiesOrder.entries()) {
                                                                            for (const [equipmentIndex, equipment] of activity.equipmentUsed.entries()) {
                                                                                if (!equipment.idEquipmentUsed) {
                                                                                    console.log(equipmentIndex, " < equipment pendiente de guardar", equipment, " en actividad ", index, activity);
                                                                                    toast.error("Existe una actividad con productos pendientes de guardar. Por favor validarlo.");
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                        setOpenAddPhotosModal(true);
                                                                        setIdActivitiesOrder(item.idActivitiesOrder);
                                                                    }}
                                                                />
                                                            )}

                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            {item.photosReports.length === 0 ? (
                                                                <Typography variant="body2" color="textSecondary">
                                                                    No hay fotografías para esta actividad.
                                                                </Typography>
                                                            ) : (
                                                                <ListaImagen itemData={item.photosReports.map((photo: any) => (
                                                                    {
                                                                        img: photo.urlPhotoReport,
                                                                        title: 'Actividad',
                                                                        author: item.activityName,
                                                                        id: photo.idPhotoReport,
                                                                        status: item.activityStatus,
                                                                    }
                                                                ))} refetch={refetch} />
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                </AccordionDetails>
                                                <AccordionActions>
                                                    <Button size="small" color="error" onClick={() => onRealizado(index, 'CANCELADO')}
                                                        disabled={item.activityStatus === "CANCELADO" || item.activityStatus === "REALIZADO" ? true : false}
                                                    >Cancelar Actividad</Button>
                                                    <Button size="small" color="success" onClick={() => onRealizado(index, 'REALIZADO')}
                                                        disabled={item.activityStatus === "CANCELADO" || item.activityStatus === "REALIZADO" ? true : false}
                                                    >Registrar Actividad</Button>
                                                </AccordionActions>
                                            </Accordion>
                                        </Grid>
                                    </Grid >
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Divider sx={{ my: 2 }} style={{ color: "black" }} />
                                        </Grid>
                                    </Grid>
                                </>
                            )
                        })}


                    </Grid>

                    <Grid container spacing={3} mt={2}>
                        <Grid item xs={12}>
                            <TabTextLabel
                                text={"INFORMACIÓN PRIMERA JORNADA LABORAL"}
                                mt={0}
                                pb={2}
                                pl={0}
                                pt={2}
                            />
                        </Grid>

                        <TimeClockComponente
                            label="Inicio de la jornada"
                            defaultValue={form.getValues().startTimeOrder || ''}
                            size={gridSizeMdLg3}
                            control={control}
                            error={errors.startTimeOrder}
                            name="startTimeOrder"
                            enableDateTypeResult={true}
                            helperText={errors.startTimeOrder?.message ?? ''}
                        />
                        <TimeClockComponente
                            label="Fin de la Jornada"
                            defaultValue={form.getValues().endTimeOrder || ''}
                            size={gridSizeMdLg3}
                            control={control}
                            error={errors.endTimeOrder}
                            name="endTimeOrder"
                            enableDateTypeResult={true}
                            helperText={errors.endTimeOrder?.message ?? ''}
                        />
                        <CustomNumberTextField
                            label="Almuerzo (Horas)"
                            defaultValue={form.getValues().lunchTime || 0}
                            size={gridSizeMdLg3}
                            control={control}
                            error={errors.lunchTime}
                            helperText={errors.lunchTime?.message ?? ''}
                            name="lunchTime"
                        />
                        <CustomNumberTextField
                            label="# Horas Extras"
                            defaultValue={form.getValues().overtime || 0}
                            size={gridSizeMdLg3}
                            control={control}
                            error={errors.overtime}
                            helperText={errors.overtime?.message ?? ''}
                            name="overtime"
                        />
                    </Grid>

                    <Grid container spacing={3} mt={2}>
                        <Grid item xs={12}>
                            <TabTextLabel
                                text={"INFORMACIÓN SEGUNDA JORNADA LABORAL (OPCIONAL)"}
                                mt={0}
                                pb={2}
                                pl={0}
                                pt={2}
                            />
                        </Grid>

                        <TimeClockComponente
                            label="Inicio de la jornada"
                            defaultValue={form.getValues().startTimeOrder2 || ''}
                            size={gridSizeMdLg3}
                            control={control}
                            error={errors.startTimeOrder2}
                            name="startTimeOrder2"
                            enableDateTypeResult={true}
                            helperText={errors.startTimeOrder2?.message ?? ''}
                        />
                        <TimeClockComponente
                            label="Fin de la Jornada"
                            defaultValue={form.getValues().endTimeOrder2 || ''}
                            size={gridSizeMdLg3}
                            control={control}
                            error={errors.endTimeOrder2}
                            name="endTimeOrder2"
                            enableDateTypeResult={true}
                            helperText={errors.endTimeOrder2?.message ?? ''}
                        />
                        <CustomNumberTextField
                            label="Almuerzo (Horas)"
                            defaultValue={form.getValues().lunchTime2 || 0}
                            size={gridSizeMdLg3}
                            control={control}
                            error={errors.lunchTime2}
                            helperText={errors.lunchTime2?.message ?? ''}
                            name="lunchTime2"
                        />
                        <CustomNumberTextField
                            label="# Horas Extras"
                            defaultValue={form.getValues().overtime2 || 0}
                            size={gridSizeMdLg3}
                            control={control}
                            error={errors.overtime2}
                            helperText={errors.overtime2?.message ?? ''}
                            name="overtime2"
                        />
                    </Grid>

                </SingleFormBoxScene>

            </SingleTableBoxScene >


            {/* ----------- Modals ----------- */}
            {
                openAddPhotosModal && (
                    <AddPhotosModal
                        open={openAddPhotosModal}
                        setOpen={setOpenAddPhotosModal}
                        idActivitiesOrder={idActivitiesOrder}
                        refetch={refetch}
                        onSave={onSave}
                    />
                )
            }

            {
                openAddEquipamentsModal && (
                    <AddEquipamentsModal
                        open={openAddEquipamentsModal}
                        setOpen={setOpenAddEquipamentsModal}
                        idActivitiesOrder={idActivitiesOrder}
                        form={form}
                    />
                )
            }

            {
                openRemoverEquipamentsModal && (
                    <RemoverEquipamentsModal
                        open={openRemoverEquipamentsModal}
                        setOpen={setOpenRemoverEquipamentsModal}
                        idActivitiesOrder={idActivitiesOrder}
                        codeUbicacionActivitiesOrder={codeUbicacionActivitiesOrder}
                        form={form}
                    />
                )
            }

            {
                openSelectSeriesModal.status && (
                    <SelectSeriesModal
                        open={openSelectSeriesModal.status}
                        data={openSelectSeriesModal.data}
                        setOpen={(status: boolean) => setOpenSelectSeriesModal(prev => ({ ...prev, status }))}
                        activityIndex={openSelectSeriesModal.activityIndex}
                        equipmentIndex={openSelectSeriesModal.equipmentIndex}
                        form={form}
                    />
                )
            }

        </>
    );
}